import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faPaperPlane } from '@fortawesome/free-solid-svg-icons'
import { useEffect } from 'react'

// MUI
import { Skeleton } from '@mui/material'

// Utils & API
import IngresosInsights from '../../Administracion/Ingresos/ingresosInsights/IngresosInsights'

/* -------------------------------------------------------------------------- */
/*              Componente principal: FooterVisionDelNegocio                */
/* -------------------------------------------------------------------------- */
const FooterVisionDelNegocio = ({summaryData,stateIngresoEgreso}) => {
  // Estado para controlar la pestaña activa

  useEffect(() => {
    // Inicializa Swapy en el contenedor
    const container = document.querySelector('.swapy-container')
    if (container && window.Swapy) {
      window.Swapy.createSwapy(container, {
        transition: 'ease-in-out',
        duration: 300,
        adaptSlotSize: true, // Asegura que los slots se adapten dinámicamente
      })
    }
  }, [])

  return (
    <div className="relative min-h-screen flex flex-col">
        <div>
          <IngresosInsights summaryData={summaryData} stateIngresoEgreso={stateIngresoEgreso} />
        </div>
    </div>
  )
}

/* -------------------------------------------------------------------------- */
/*                       Componente: Acciones rápidas                         */
/* -------------------------------------------------------------------------- */
const accionesRapidasLinks = [
  { name: 'Registrar ingreso', icon: <FontAwesomeIcon className="" icon={faLink} size="lg" />, link: '/business-insights' },
  { name: 'Registrar Gasto', icon: <FontAwesomeIcon className="" icon={faLink} size="lg" />, link: '/business-insights' },
  { name: 'Agregar Cliente', icon: <FontAwesomeIcon className="" icon={faLink} size="lg" />, link: '/business-insights' },
  { name: 'Agregar Proveedor', icon: <FontAwesomeIcon className="" icon={faLink} size="lg" />, link: '/business-insights' },
  { name: 'Plan de cuentas', icon: <FontAwesomeIcon className="" icon={faLink} size="lg" />, link: '/business-insights' },
  { name: 'Crear obligaciones', icon: <FontAwesomeIcon className="" icon={faLink} size="lg" />, link: '/business-insights' },
]

export const AccionesRapidas = () => (
  <div className="bg-primary h-full w-full rounded-card text-white/80 p-6 grid grid-cols-3 place-content-between gap-x-7 shadow-card">
    <h2 className="col-span-3">Acciones rápidas</h2>
    {accionesRapidasLinks.map((link, index) => (
      <div key={index} className="flex flex-col items-center justify-center gap-1 cursor-pointer">
        <figure className="w-12 h-12 rounded-full bg-white/30 flex items-center justify-center">
          {link.icon}
        </figure>
        <div className="text-xs text-center">{link.name}</div>
      </div>
    ))}
  </div>
)

/* -------------------------------------------------------------------------- */
/*                          Componente: Tareas                              */
/* -------------------------------------------------------------------------- */
const tareasList = [
  { name: 'Conciliar factura #123 con movimientos del banco', status: 'pendiente', icon: <FontAwesomeIcon className="" icon={faPaperPlane} size="sm" /> },
  { name: 'Completar rendición de gasto #32', status: 'pendiente', icon: <FontAwesomeIcon className="" icon={faPaperPlane} size="sm" /> },
  { name: 'Conciliar factura #124 con movimientos del banco', status: 'pendiente', icon: <FontAwesomeIcon className="" icon={faPaperPlane} size="sm" /> },
  { name: 'Revisar estado de pago de facturas por cobrar', status: 'pendiente', icon: <FontAwesomeIcon className="" icon={faPaperPlane} size="sm" /> },
  { name: 'Agregar obligación para ingreso de $1.234.530', status: 'pendiente', icon: <FontAwesomeIcon className="" icon={faPaperPlane} size="sm" /> },
]

export const Tareas = () => (
  <div className="rounded-card bg-surface border border-border w-full h-full flex flex-col justify-between shadow-card">
    <div className="p-6">
      <h2 className="text-xl font-bold text-text">Tareas</h2>
      <p className="text-sm italic text-muted">
        Necesitamos que nos ayudes a entender algunos de los movimientos del negocio
      </p>
    </div>
    <ul
      style={{ scrollbarWidth: 'thin', scrollbarColor: '#c7c7c7 #f5f5f5' }}
      className="flex flex-col h-[190px] overflow-y-auto pb-2 mb-4"
    >
      {tareasList.map((tarea, index) => (
        <li key={index} className="px-9 py-2 flex items-center justify-between even:bg-border/40">
          <div className="text-[14px] font-medium text-text">{tarea.name}</div>
          <div className="w-7 h-7 rounded-full bg-surface shadow-card flex items-center justify-center text-muted mr-1">
            {tarea.icon}
          </div>
        </li>
      ))}
    </ul>
  </div>
)

/* -------------------------------------------------------------------------- */
/*                    Componente: MovimientosBancarios                      */
/* -------------------------------------------------------------------------- */


/* -------------------------------------------------------------------------- */
/*                   Componente: UltimosDocumentos                          */
/* -------------------------------------------------------------------------- */

export const SkeletonGrid = ({ minHeight = 22, length = 5 }) => (
  <>
    {Array.from({ length }).map((_, i) => (
      <Skeleton sx={{ borderRadius: 5 }} key={i} variant="rounded" style={{ minHeight }} />
    ))}
  </>
)

export default FooterVisionDelNegocio
